import { useEffect } from 'react';
import { useEsriMapStore } from './use-esri-map-store';
import { LOCATION_INACCURATE_CHECK_INTERVAL } from '../configuration';

export function useInaccurateLocationCheckInterval() {
    const mapStore = useEsriMapStore();

    useEffect(
        function checkGpsLocationInaccuracyInterval() {
            const intervalId = setInterval(() => {
                mapStore.refreshMapViewportUnitsPotentialInaccuracy();
            }, LOCATION_INACCURATE_CHECK_INTERVAL);

            return () => clearInterval(intervalId);
        },
        [mapStore]
    );
}
